<script lang="ts">
  import { reveal } from '../actions';
  let { dimmed = false }: { dimmed?: boolean } = $props();
</script>

<section class="coda" class:dimmed>
  <div class="wrap reveal" use:reveal>
    <svg class="ring" viewBox="0 0 100 100" aria-hidden="true">
      <circle
        cx="50"
        cy="50"
        r="40"
        fill="none"
        stroke="var(--mercury)"
        stroke-width="2"
        stroke-dasharray="226 26"
        stroke-linecap="round"
        filter="url(#glow)"
      />
      <path d="M48,11 l6,-3 l-1,6 z" fill="var(--mercury)" />
    </svg>
    <h2>Уроборос почти сомкнулся</h2>
    <p>
      Четыре карты дали всю длину окружности тебя. Замыкает её не ещё-ты, а то, что —
      <i>не ты</i>: сознание, которое ты не авторствуешь, реальное, сопротивляющееся редактированию.
      Зазор между пастью и хвостом — не дефект, а проём, единственное место, куда входит Другой и новое.
      У замкнутого круга нет двери.
    </p>
    <div class="sig">Семя — здесь · ты уже начал</div>
  </div>
</section>

<style>
  .coda.dimmed {
    opacity: 0.4;
    transition: opacity 0.3s;
    pointer-events: none;
  }
</style>
